<template>
  <vl-icon :icon="getIcon" class="status-icon" :style="getStyle" />
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps({
  id: {
    type: Number,
    required: true
  }
});

const getIcon = computed(() => {
  let icon = '';
  switch (props.id) {
    case 0:
      icon = 'lock-unlock';
      break;
    default:
      icon = 'lock';
      break;
  }
  return icon;
});

const getStyle = computed(() => {
  let color = 'green';

  switch (props.id) {
    case 0:
      color = 'gray';
      break;
    case 1:
      color = 'green';
      break;
    case 2:
      color = 'red';
      break;
    case 3:
      color = 'black';
      break;
  }
  return {
    color
  };
});
</script>

<style lang="scss" scoped>
.status-icon {
  font-size: 24px;
}
</style>
